// src/components/Guide.js
import React, { useState } from 'react';
import { Icons } from '../components/Icons';

const guideSections = [
  {
    id: 'intro',
    title: 'Введение',
    icon: Icons.Shield,
    content: `
      Atri Bot — это продвинутый модератор для Telegram-чатов. Бот работает автоматически 24/7 и 
      выполняет всю рутинную работу по поддержанию порядка в вашем чате.
      
      Для работы бота необходимо:
      1. Добавить бота в чат (@AtriGuard_bot)
      2. Назначить бота администратором
      3. Выдать боту все права администратора
      
      После этого бот готов к работе. Все настройки управляются через команды в чате.
    `
  },
  {
    id: 'setup',
    title: 'Начало работы',
    icon: Icons.Command,
    content: `
      Первые шаги с Atri Bot:
      
      1. Добавьте бота в чат: @AtriGuard_bot
      2. Назначьте бота администратором
      3. Напишите в чате /commands — бот покажет все доступные команды
      4. Настройте бота под свой чат через /settings
      5. Для доступа к веб-панели используйте /onlinepanel
      
      Важно! Бот должен иметь все права администратора для полноценной работы.
    `
  },
  {
    id: 'admin-panel',
    title: 'Онлайн-панель администратора',
    icon: Icons.Settings,
    content: `
      Онлайн-панель — это веб-интерфейс для управления чатами через браузер.
      
      Как получить доступ:
      1. Напишите /start в лс боту (если вы ещё этого не сделали)
      2. Напишите /onlinepanel в чате, где вы администратор
      3. Бот проверит ваши права и пришлёт секретный код в личные сообщения
      4. Перейдите на сайт atri-bot.online и введите полученный код
      5. После входа вы увидите все свои добавленные чаты
      6. Чтобы добавить ещё несколько чатов, где есть этот бот и вы являетесь администратором, напишите в нужном чате /onlinepanel 
      
      В панели можно:
      - Просматривать список ваших чатов
      - Управлять настройками каждого чата
      - Видеть информацию о наказаниях пользователей, возможность изменять их причину или отменять их
      - Видеть статистику о работе администрации, последних наказаниях, почасовой активности пользователей и самых активных пользователей
      
      Ваш секретный код можно обновить через /updatesecretcode в личных сообщениях боту.
      Никому не сообщайте свой секретный код, даже оператору службы поддержки!
    `
  },
  {
    id: 'moderation',
    title: 'Модерация',
    icon: Icons.Shield,
    content: `
      Полный набор инструментов для модерации:
      
      Предупреждения (/warn, /unwarn)
      - Выдавайте предупреждения нарушителям
      - Можно указать причину
      - Флаг -d удаляет сообщение нарушителя
      - Флаг -i делает предупреждение бессрочным
      - Предупреждения автоматически снимаются через заданное время
      
      Мут (/mute, /unmute)
      - Запрет на отправку сообщений
      - Можно указать срок: 5m, 2h, 3d, 1M
      - Можно указать причину
      - Автоматическое снятие по истечении срока
      
      Бан (/ban, /unban)
      - Полная блокировка в чате
      - Можно указать срок
      - Можно указать причину
      
      Заметки (/note, /unnote)
      - Создавайте заметки о пользователях
      - Просматривайте в информации о пользователе
      - Удаляйте по номеру
      
      Информация о пользователе (/user)
      - Просмотр всех данных пользователя
      - Флаг -f для полной информации
      - Флаг -mc для отправки в чат модерации
    `
  },
  {
    id: 'reports',
    title: 'Система репортов',
    icon: Icons.MessageSquare,
    content: `
      Пользователи могут сообщать о нарушениях через команду /report.
      
      Как работает репорт:
      1. Пользователь отвечает на сообщение нарушителя командой /report
      2. Можно указать причину репорта
      3. Бот отправляет репорт в чат модерации
      4. Администраторы видят репорт с кнопками действий
      
      Кнопки для администраторов:
      - Предупреждение — выдаёт предупреждение нарушителю
      - Мут — выдаёт мут на время, указанное в настройках
      - Бан — блокирует нарушителя
      - Отклонить — закрывает репорт без наказания
      
      Для работы репортов настройте чат модерации (modchatID).
    `
  },
  {
    id: 'raid-protection',
    title: 'Защита от рейдов',
    icon: Icons.Zap,
    content: `
      Автоматическая защита от массовых вступлений.
      
      Как работает:
      1. Бот отслеживает количество новых участников за 15 секунд
      2. При превышении порога активируется режим рейда
      3. Все новые участники автоматически исключаются
      4. Простым пользователям запрещается писать в чат
      5. Администраторы остаются не затронутыми
      
      Настройки антирейда:
      - autoRaidMode — включить/выключить автоматический режим
      - raidSensitivity — уровень чувствительности (1-5)
      
      Уровни чувствительности:
      1 — минимальный (5 вступлений за 15 сек) для тихих чатов
      2 — низкий (7 вступлений)
      3 — средний (10 вступлений) — по умолчанию
      4 — высокий (15 вступлений) для активных чатов
      5 — максимальный (25 вступлений) для очень активных чатов
      
      Ручное управление:
      /raidMode — включить вручную
      /unRaidMode — отключить вручную
    `
  },
  {
    id: 'captcha',
    title: 'Капча для новых участников',
    icon: Icons.Lock,
    content: `
      Защита от ботов и спамеров через проверку капчи.
      
      Настройки капчи:
      - captchaEnabled — включить/выключить капчу
      - captchaType — тип капчи: simple или hard
      - captchaKickEnabled — исключать при непрохождении через 5 минут
      
      Типы капчи:
      - simple — простая капча, нужно нажать кнопку "Я человек"
      - hard — продвинутая капча, нужно решить математический пример
      
      Как работает:
      1. Новый участник заходит в чат
      2. Бот отправляет сообщение с капчей
      3. Участник должен пройти проверку
      4. Если капча не пройдена за 5 минут — участник исключается
      5. После успешной проверки участник может писать в чат
      
      При включении капчи автоматически включается приветственное сообщение.
    `
  },
  {
    id: 'auto-messages',
    title: 'Автоматические сообщения',
    icon: Icons.Clock,
    content: `
      Планирование автоматических сообщений в чат.
      
      Настройки авто-сообщений:
      - autoMessageEnabled — включить/выключить
      - autoMessageInterval — интервал отправки (1h, 30m, 2d, 1M)
      - autoMessageText — текст сообщения
      
      Как настроить несколько сообщений:
      Разделяйте сообщения строкой ~*~
      
      Пример:
      "Привет всем!~*~Сегодня отличный день!~*~Не забывайте правила чата!"
      
      Ограничения:
      - До 6 сообщений
      - Каждое сообщение до 700 символов
      - Сообщения отправляются по очереди с каждым интервалом
      
      При выключении autoMessageEnabled все расписания отменяются.
    `
  },
  {
    id: 'auto-comment',
    title: 'Авто-комментарии к постам',
    icon: Icons.Check,
    content: `
      Автоматическое комментирование постов из канала.
      
      Настройки авто-комментария:
      - autoComment — включить/выключить
      - autoCommentText — текст комментария
      - autoCommentTextEnd — текст в конце комментария
      - mediaRestrictionEnabled — ограничить медиа после комментария
      - mediaRestrictionDuration — длительность ограничения медиа
      
      Как работает:
      1. В чате, привязанном к каналу, публикуется пост
      2. Бот автоматически комментирует его в чате
      3. Можно временно запретить отправку медиа-файлов
      
      Если чат не является чатом для комментариев канала — выключите autoComment.
    `
  },
  {
    id: 'settings-details',
    title: 'Все настройки чата',
    icon: Icons.Settings,
    content: `
      Полный список настроек с пояснениями:
      
      Основные настройки
      - modchatID — ID чата для репортов и модерации
      - commandCd — задержка между командами для пользователей (сек)
      
      Предупреждения
      - warnExpireTime — срок снятия предупреждений (5m, 2h, 3d, 1M)
      - warnPunishmentCount — количество предупреждений до наказания
      - warnPunishment.type — тип наказания: mute или ban
      - warnPunishment.duration — длительность наказания или null (навсегда)
      
      Мут
      - quickMuteDuration — длительность мута через кнопку в репорте
      
      Авто-комментарий
      - autoComment — включить/выключить
      - autoCommentText — текст комментария
      - autoCommentTextEnd — концовка комментария
      - mediaRestrictionEnabled — ограничить медиа после комментария
      - mediaRestrictionDuration — длительность ограничения медиа
      
      Антирейд
      - autoRaidMode — автоматическое обнаружение рейдов
      - raidSensitivity — чувствительность (1-5)
      
      Автоудаление
      - autoDeleteEnabled — автоудаление сообщений бота
      - autoDeleteDuration — время до автоудаления (3m, 1h, 1d, 1M)
      
      Приветствия
      - welcomeMessageEnabled — приветствие новых участников
      - welcomeMessageText — текст приветствия (?name — упоминание)
      
      Капча
      - captchaEnabled — проверка капчи
      - captchaType — тип: simple или hard
      - captchaKickEnabled — исключать при непрохождении через 5 минут
      
      Авто-сообщения
      - autoMessageEnabled — автоматическая отправка сообщений
      - autoMessageInterval — частота отправки
      - autoMessageText — текст сообщений (до 6 через ~*~)
      
      Прочее
      - allowKickme — разрешить пользователям выгонять себя
    `
  },
  {
    id: 'support',
    title: 'Служба поддержки',
    icon: Icons.Users,
    content: `
      Встроенная система тикетов для обращений в службу поддержки.
      
      Как создать тикет:
      1. Напишите /help в личные сообщения боту
      2. Укажите тему запроса (до 100 символов)
      3. Опишите проблему (до 800 символов)
      4. Выберите срочность: максимальная, умеренная, низкая
      5. Можно прикрепить до 5 медиафайлов
      
      После создания тикета:
      - Вы получаете номер тикета
      - Создаётся ветка в чате поддержки
      - Вы можете отправлять дополнительные сообщения через кнопку      
      
      Просмотр тикетов: /tickets в личных сообщениях боту.
    `
  },
  {
    id: 'logging',
    title: 'Логирование и хранение данных',
    icon: Icons.Hash,
    content: `
      Все действия сохраняются для удобного анализа.
      
      Что хранится:
      - Все муты, баны, предупреждения, заметки
      - История репортов
      - Данные о пользователях
      - Логи всех действий администраторов
      
      В целях конфиденциальности, не все логи доступны простым администраторам.
      Если вам по какой-то причине нужны полные логи, напишите в поддержку боту и опишите причину.
    `
  }
];

function Guide() {
  const [activeSection, setActiveSection] = useState('intro');

  return (
    <section id="guide" className="guide">
      <div className="container">
        <div className="section-header">
          <h2>Подробная инструкция</h2>
          <p>Полное руководство по всем функциям Atri Bot</p>
        </div>
        <div className="guide-content">
          <div className="guide-nav">
            {guideSections.map((section) => (
              <button
                key={section.id}
                className={`guide-nav-btn ${activeSection === section.id ? 'active' : ''}`}
                onClick={() => setActiveSection(section.id)}
              >
                <section.icon />
                <span>{section.title}</span>
              </button>
            ))}
          </div>
          <div className="guide-content-main">
            {guideSections.map((section) => (
              <div
                key={section.id}
                className={`guide-section ${activeSection === section.id ? 'active' : ''}`}
              >
                <div className="guide-section-header">
                  <section.icon />
                  <h3>{section.title}</h3>
                </div>
                <div className="guide-section-content">
                  {section.content.split('\n').map((paragraph, index) => {
                    const trimmed = paragraph.trim();
                    if (trimmed.startsWith('-')) {
                      return <li key={index}>{trimmed.substring(1).trim()}</li>;
                    }
                    if (trimmed.match(/^\d+\./)) {
                      return <li key={index}>{trimmed}</li>;
                    }
                    if (trimmed && !trimmed.startsWith('#')) {
                      return <p key={index}>{trimmed}</p>;
                    }
                    return null;
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Guide;